const USER_ROLES = {
  // Tipos de usuário
  ROLE_ADMIN: 'Administrador',
  ROLE_ANALISTA_AGNES: 'Analista Agnes',

  // Menu "Saúde e segurança"
  ROLE_MENU_SAUDE_SEGURANCA_AGENTES_NOCIVOS_APOSENTADORIA_ESPECIAL: 'Agentes nocivos e aposentadoria especial',

  // Menu "Trabalhador"
  ROLE_MENU_AFASTADOS_INATIVOS: 'Afastamento e inatividade',
  ROLE_MENU_CBO: 'CBO',
  ROLE_MENU_HORARIOS_JORNADA: 'Horários e Jornada',

  // Menu "Folha de pagamento"
  ROLE_MENU_EMPREGADORES: 'Empregadores',
  ROLE_MENU_FOLHA_PAGAMENTO: 'Folha de pagamento',

  // Menu "Encargos"
  ROLE_MENU_ENCARGOS_DCTF: 'DCTF',
  ROLE_ACTION_ATUALIZAR_DADOS_DCTF: 'DCTF Atualizar Dados',
  ROLE_MENU_ENCARGOS_MENSAGENS: 'Mensagens e-CAC',
  ROLE_MENU_ENCARGOS_OPORTUNIDADES: 'Oportunidades',
  ROLE_ENCARGOS_OPORTUNIDADES_EDITAR: 'Oportunidades - Editor',

  // Menu "e-Gov"
  ROLE_MENU_EGOV: 'e-gov',
  ROLE_MENU_CESSAO: 'Cessão',

  // Menu "Certidões"
  ROLE_MENU_CERTIDAO_FEDERAL: 'Certidão Federal',
  ROLE_MENU_CRF: 'CRF',
  ROLE_CRF_EDITAR: 'CRF - Editor',
  ROLE_CERTIDOES_ATUALIZAR_DADOS: 'Certidões - Atualizar dados',

  // Menu "Configurações"
  ROLE_MENU_CENTRAL_REPROCESSAMENTO: 'Central de Reprocessamento',
  ROLE_IMPORTACAO: 'Importação',
  ROLE_CONFIG_RUBRICAS_INCIDENCIAS_NATUREZA: 'Configurações - Rubricas - Incidências por natureza',
  ROLE_CONFIG_RUBRICAS_CLASSIFICACAO_ANALISE: 'Configurações - Rubricas - Classificação de Análise',
  ROLE_CONFIG_CBO_CLASSIFICACAO_ANALISE: 'Configurações - CBO - Classificação de Análise',
  ROLE_CONFIG_HORARIOS_JORNADA_CLASSIFICACAO_ANALISE:
    'Configurações - Horários e Jornadas - Classificação de Análise',
};

export default USER_ROLES;
